import { PropsWithChildren } from 'react';
import { Platform } from 'react-native';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { ROUTES } from '@/common/constants/routes';
import { usePagesMigrations } from '@/common/hooks/usePagesMigration';
import { usePathname } from 'expo-router';
import { styles } from './TabsContentWrapper.styles';

export function TabsContentWrapper({ children }: PropsWithChildren) {
  const pathname = usePathname();
  const { isPageMigrated } = usePagesMigrations(pathname);
  const noPadding = [ROUTES.MEAL_NETWORK, ROUTES.SCHOOLS_NETWORK].some(
    (route) => pathname === route
  );

  if (Platform.OS !== 'web' || isPageMigrated) {
    return <>{children}</>;
  }

  return (
    <PageLayout className={noPadding ? styles.noPadding : ''}>
      {children}
    </PageLayout>
  );
}
